import { LogsAPI } from '@business/api/logs';
import { LogRequest, LogResponse } from '@business/entities/log';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { map } from 'rxjs/operators';

export class LogBloc extends BaseBloc {
  private readonly logsRepo = new Repository<LogResponse>({
    getItemId: item => item.logId,
  });

  readonly logs$ = this.logsRepo.items$.pipe(
    map(items => {
      return R.sortBy(items, i => -i.createdAt);
    }),
  );

  onReset() {
    this.logsRepo.reset();
  }

  fetchLogs = (request: LogRequest, reset = false) => {
    if (reset) {
      this.logsRepo.reset();
    }
    return LogsAPI.fetchLogs(request).pipe(this.logsRepo.ops.upsertMany(item => ({ item })));
  };

  addNew = (item: LogResponse) => {
    this.logsRepo.addOne(item);
  };
}
